import './Carousel.less';
import type { ComponentChild } from 'preact';
import { useState } from 'preact/hooks';
import IconButton from '../button/IconButton';

export type CarouselProps = {
    className?: string;
    items: ComponentChild[];
    visibleItems?: number;
    gap?: number;
    stepSize?: number;
};

const Carousel = ({
    className = '',
    items,
    visibleItems = 4,
    stepSize = 4,
    gap = 24
}: CarouselProps) => {
    const [startIndex, setStartIndex] = useState(0);
    const maxIndex = Math.max(0, items.length - visibleItems);

    const handlePrev = () => {
        setStartIndex(prev => Math.max(0, prev - stepSize));
    };
    const handleNext = () => {
        setStartIndex(prev => Math.min(maxIndex, prev + stepSize));
    };

    const showPrev = startIndex > 0;
    const showNext = startIndex < maxIndex;

    const itemWidth = `calc((100% - ${
        (visibleItems - 1) * gap
    }px) / ${visibleItems})`;
    const translateX = `calc(-1 * (${startIndex} * (${itemWidth} + ${gap}px)))`;

    return (
        <div
            className={`bri-Carousel ${className}`}
            style={{
                '--carousel-visible-items': visibleItems,
                '--carousel-gap': `${gap}px`
            }}
        >
            <IconButton
                variant="default"
                iconId="chevron-left"
                onClick={handlePrev}
                disabled={!showPrev}
                className={`bri-Carousel-control bri-Carousel-control-prev ${
                    showPrev ? '' : 'bri-Carousel-control-hidden'
                }`}
            />
            <div className="bri-Carousel-viewport">
                <div
                    className="bri-Carousel-items"
                    style={{ transform: `translateX(${translateX})` }}
                >
                    {items.map((item, index) => (
                        <div key={index} className="bri-Carousel-item">
                            {item}
                        </div>
                    ))}
                </div>
            </div>
            <IconButton
                variant="default"
                iconId="chevron-right"
                onClick={handleNext}
                disabled={!showNext}
                className={`bri-Carousel-control bri-Carousel-control-next ${
                    showNext ? '' : 'bri-Carousel-control-hidden'
                }`}
            />
        </div>
    );
};

export default Carousel;
